// Wave AW.3-React (2026-05-16) — 가입 신청 후 검토 대기 화면.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoFull } from '../Logo';

function AuctionBuyerPending() {
  var navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(180deg,#f8fafc 0%,#eff6ff 100%)',
      fontFamily: "'Pretendard',sans-serif", padding: 20,
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: -200, right: -200, width: 600, height: 600, background: '#dbeafe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4 }} />
      <div style={{ position: 'absolute', bottom: -200, left: -200, width: 500, height: 500, background: '#e0f2fe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4 }} />

      <div style={{ width: '100%', maxWidth: 480, position: 'relative', zIndex: 10 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <LogoFull iconSize={36} fontSize={24} />
        </div>

        <div style={{ backgroundColor: 'white', borderRadius: 20, padding: '48px 36px', boxShadow: '0 4px 40px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', textAlign: 'center' }}>
          <div style={{ width: 72, height: 72, margin: '0 auto 24px', borderRadius: '50%', background: 'linear-gradient(135deg, #fef3c7, #fde68a)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>
            ⏳
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', marginBottom: 12 }}>가입 신청 완료</h2>
          <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 8 }}>
            제출하신 사업자등록증을 관리자가 검토하고 있습니다.
          </p>
          <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 28 }}>
            보통 1영업일 이내에 결과를 이메일로 알려드립니다.
          </p>

          <div style={{ background: '#f8fafc', borderRadius: 12, padding: 16, marginBottom: 24, textAlign: 'left' }}>
            <p style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginBottom: 8 }}>📋 다음 단계</p>
            <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#475569', lineHeight: 1.8 }}>
              <li>관리자 검토 (사업자등록증 + 정보 확인)</li>
              <li>승인 시 이메일 알림 발송</li>
              <li>로그인 후 경매 입찰 가능</li>
            </ul>
          </div>

          <button type="button" onClick={function(){navigate('/buyer/login')}}
            style={{
              width: '100%', height: 44,
              background: 'white',
              color: '#1B3A5C', border: '1.5px solid #cbd5e1', borderRadius: 12,
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
              fontFamily: "'Pretendard',sans-serif",
            }}>
            로그인 화면으로
          </button>
        </div>

        <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, marginTop: 24 }}>
          문의: support@autodex.kr
        </p>
      </div>
    </div>
  );
}

export default AuctionBuyerPending;
